export default __webpack_public_path__ + "static/media/ImageDropper.97ab3805.svg";